import { render, staticRenderFns } from "./ReturnToActivityFeed.vue?vue&type=template&id=c25367c8&scoped=true&"
import script from "./ReturnToActivityFeed.vue?vue&type=script&lang=js&"
export * from "./ReturnToActivityFeed.vue?vue&type=script&lang=js&"
import style0 from "./ReturnToActivityFeed.vue?vue&type=style&index=0&id=c25367c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25367c8",
  null
  
)

export default component.exports